module.exports = __webpack_public_path__ + "img/linkedin.251c27f.png";